<template>
  <img src="/logo-horizontal.webp" alt="Full Life" :style="{ maxHeight: `${props.height}px` }" />
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    height?: number
  }>(),
  {
    height: 18,
  },
)
</script>
